import type { INoteTemplateOption } from '@/interfaces'
import { NoteSectionType } from '@/interfaces'

export const NoteTypeNames: INoteTemplateOption[] = [
  {
    name: 'History of Present Illness',
    value: NoteSectionType.HPI,
  },
  {
    name: 'Review of Systems',
    value: NoteSectionType.ROS,
  },
  {
    name: 'Physical Exam',
    value: NoteSectionType.PE,
  },
  {
    name: 'Assessment and Plan',
    value: NoteSectionType.AP,
  },
  {
    name: 'Patient Instructions',
    value: NoteSectionType.PATIENT_INSTRUCTIONS,
  },
  {
    name: 'Discussion Notes',
    value: NoteSectionType.DISCUSSION_NOTES,
  },
]
